// extracted by mini-css-extract-plugin
export var square = "_9c8f46ef6f2b18c312b26b6054c2750b-css";
export var label = "_895ada3f5a3e5028ab7d1233151f8012-css";